<template>
  <div
    class="py-2 px-4 fsize12 bg-white rounded-full border-green text-success"
  >
  
  </div>
</template>

<script>
export default {
  props: {
    exp: Date,
  },
  data() {
    return {
      hours: "24",
      minutes: "60",
      seconds: "60",
    };
  },
 
  methods: {

  },
  async mounted() {
  //  await this.Startcondown();
  },
};
</script>
